export default "__VITE_ASSET__52sasY4xo7eTGkAzeu_5nQ__"